import { Tag, Text } from 'shell/components';
import { getGradeSnapshotDisplay, getSnapshotSemanticGrade } from 'utils/gradePushback';

const SEMANTIC_TAG_STATUSES = ['reviewed', 'complete', 'incomplete', 'excused'];

export const SemanticGradeTag = ({ value }) => {
    const status = typeof value === 'string' ? value.toLowerCase() : null;
    if (!SEMANTIC_TAG_STATUSES.includes(status)) return null;

    return <Tag type={'semantic'} value={status} />;
};

const SemanticGradeDisplay = ({ fallback = '--', snapshot }) => {
    const semanticGrade = getSnapshotSemanticGrade(snapshot);
    if (SEMANTIC_TAG_STATUSES.includes(semanticGrade)) {
        return <SemanticGradeTag value={semanticGrade} />;
    }
    return <Text>{getGradeSnapshotDisplay(snapshot, fallback)}</Text>;
};

export default SemanticGradeDisplay;
